import CryptoJS from 'crypto-js';

const AES_FILE_ENCRYPTION = {
  ENCRYPTION_KEY: "8e9f3f53c25c72d2a96b47a2ea44a9fd5636b8e736899ba1d5e4b94b28780029",
  ENCRYPTION_IV: "SHAYUJ567YHD12TG",
  ENCRYPTION_ALGORITHM: "aes-256-cbc",
};

// Function to decrypt AES encrypted data
export const decryptAESData = (encryptedData: string): any => {
  try {
    const key = CryptoJS.enc.Hex.parse(AES_FILE_ENCRYPTION.ENCRYPTION_KEY);
    const iv = CryptoJS.enc.Utf8.parse(AES_FILE_ENCRYPTION.ENCRYPTION_IV);
    
    const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    
    return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    // Decryption failed; return null so callers can handle missing data
    return null;
  }
};

// Function to encrypt data using AES
export const encryptAESData = (data: string): string => {
  try {
    const key = CryptoJS.enc.Hex.parse(AES_FILE_ENCRYPTION.ENCRYPTION_KEY);
    const iv = CryptoJS.enc.Utf8.parse(AES_FILE_ENCRYPTION.ENCRYPTION_IV);
    
    const encrypted = CryptoJS.AES.encrypt(data, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    
    return encrypted.toString();
  } catch (error) {
    // Encryption failed; return empty string as safe fallback
    return '';
  }
};

export const ROLE_PERMISSIONS_FNC = (permissions: any) => {
  if (!permissions || !Array.isArray(permissions)) return;
  const transformedPermissions: any = Object.values(
    permissions.reduce((acc, permission) => {
      if (permission && permission.slug_name && permission.action) {
        const { slug_name, action } = permission;
        if (!acc[slug_name]) {
          acc[slug_name] = { name: slug_name, data: [] };
        }
        acc[slug_name].data.push(
          action.charAt(0).toUpperCase() + action.slice(1)
        );
      }
      return acc;
    }, {})
  );

  return transformedPermissions;
};

// Function to truncate text to a specified length
export const TextTruncate = (text: any): JSX.Element => {
  const maxLength = 100; // Set maximum text length

  // Truncate the text if it exceeds maxLength
  const truncatedText =
    text.length > maxLength ? text.slice(0, maxLength) + "..." : text;

  return truncatedText; // Return truncated text inside a paragraph
};

// Function to generate a random captcha string
export const GenerateCaptcha = () => {
  return Math.random().toString(36).substring(2, 8).toUpperCase(); // Generate a 6-character alphanumeric string
};

// Get user data from localStorage
export const getUser = () =>{
let data=  JSON.parse(sessionStorage.getItem("data") as any) || null;
return {...data,roles:decryptAESData(data?.roles)}
}

export const getUserDataWithoutDecrypt =()=>{
  let data=  JSON.parse(sessionStorage.getItem("data") as any) || null;
  return {...data}
}

export const ROLES_SLUGS = {
  users: "users",
  roles: "roles",
  interviewer: "interviewer",
  domain: "domain",
  position: "position",
  rule: "rule",
  queryTracker:'query_tracker',
};

export const PERMISSIONS_SLUGS = {
  create: "create",
  read: "read",
  edit: "update",
  delete: "delete",
};

export const INFRACON_URLS={
  register:'https://infracon.nic.in/index.asp',
  view_profile:'https://infracon.nic.in/kp_notifications.asp?EncHid='
}